import {combineReducers} from 'redux';
import layout from './layoutReducer';
import {routerReducer} from 'react-router-redux';
import {reducer as reduxAsyncConnect} from 'redux-connect';
import auth2 from './withOtp/authReducer2';
import i18n from './i18nReducer';
import analytics from './analyticsReducer';
import {reducer as formReducer} from 'redux-form';
import {reducer as purchases} from 'purchases/redux';
import {reducer as payNow} from 'pay-now/redux';
import {reducer as authRoot2} from '../auth/authWithOtp/redux2';
import {reducer as document} from 'pdf/redux';
import {reducer as card} from 'card/redux';
import {otpReducer} from "./otpReducer";


const rootReducer = () => {
  return combineReducers({
    auth: auth2,
    authRoot: authRoot2,
    document,
    layout,
    reduxAsyncConnect,
    routing: routerReducer,
    i18n,
    payNow,
    purchases,
    form: formReducer,
    card,
    analytics,
    otpReducer,
  });
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js